"use client";

import { useGlobalTranscriptionStatus } from "@medimo/global-state";
import * as logger from "@medimo/monitor/logger";
import { LoadingMd } from "@medimo/ui";
import { useEffect } from "react";

const LONG_LOADING_THRESHOLD_MS = 10_000;

export default function Loading() {
  // WEB-212 で録音 Provider を root(app/global-recording-providers.tsx)へ引き上げた
  // ため、このフォールバックは録音 Provider を置き換えない(録音は保持される)。
  // rootLoading:mountedWhileRecording は録音消失の直接指標ではなくなったが、
  // 録音中に root loading が出た事実の観測用として残す(MEDIMO-3926)。
  // 長時間表示は初回ロードのノイズを避けるため録音外でも記録する。
  useEffect(() => {
    const context = {
      transcriptionStatus: useGlobalTranscriptionStatus.getState().status,
      sincePageLoadMs: Math.round(performance.now()),
    };
    if (context.transcriptionStatus !== "inactive") {
      logger.warn("rootLoading:mountedWhileRecording", context);
    }
    const timer = setTimeout(() => {
      logger.warn("rootLoading:visibleTooLong", {
        ...context,
        thresholdMs: LONG_LOADING_THRESHOLD_MS,
      });
    }, LONG_LOADING_THRESHOLD_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex h-screen items-center justify-center gap-3">
      <LoadingMd />
    </div>
  );
}
